import { Category } from "../../interfaces/Category";

export function isMainCategory(category: Category): boolean {
  return category.parentId === null;
}
